import React, { FC, useEffect, useState } from 'react';
import {
  Customer,
  PageWrapper,
  CustomerForm,
  useShowAlertPopup,
  ConfirmationPopupProps,
  ConfirmationPopupState,
} from '@dew21/ui';
import { useHistory, useParams } from 'react-router';
import axios from 'axios';
import { useSetRecoilState } from 'recoil';

export const EditCustomer: FC = (props) => {
  const { id } = useParams();
  const [customer, setCustomer] = useState<Customer | null>(null);
  const history = useHistory();
  const showNotificationBanner = useShowAlertPopup();
  const setShowDeletePopup = useSetRecoilState<ConfirmationPopupProps>(ConfirmationPopupState);

  const fetchCustomer = () => {
    return axios.get(`/api/customers/${id}`);
  };

  const deleteCustomer = () => {
    return axios.delete(`/api/customers/${id}`);
  };

  useEffect(() => {
    if (id) {
      fetchCustomer().then((response) => {
        setCustomer(response.data);
      }).catch((e) => {
        console.log(e);
      });
    }
  }, []);

  return <PageWrapper
    breadCrumb={[{ title: 'Kunden', path: '/customers' }, { title: 'Bearbeiten', path: `/customers/${id}` }]}
    marginal={{
      items: [
        {
          text: 'Kunden löschen',
          icon: 'trash',
          actionFn: () => {

            setShowDeletePopup({
              config: {
                open: true,
                actionButtonLabel: 'Löschen',
                closeFn: () => {
                  setShowDeletePopup({ config: null });
                },
                actionFn: () => {
                  deleteCustomer().then((response) => {
                    showNotificationBanner({ renderContent: () => <>Der Kunde wurde erfolgreich gelöscht.</> });
                    history.push('/customers');
                  }).catch((error) => {
                    console.log(error);
                    showNotificationBanner({
                      error: true,
                      renderContent: () => <>Bei dem Versuch den Kunden zu löschen ist ein Fehler aufgetreten.</>,
                    });
                  });
                },
                renderer: () => {
                  return <>Möchten Sie den Kunden </>;
                },
              },
            });

          },
        }],
    }}>
    {customer !== null ? <CustomerForm
      onCancel={() => {
        history.push('/customers');
      }}
      customer={customer}
      setCustomer={(customer: Customer) => {
        axios.put(`/api/customers/${customer.id}`, customer).then((response) => {
          setCustomer(response.data);
          showNotificationBanner({ renderContent: () => <>Der Kunde wurde gespeichert.</> });
          history.push('/customers');
        }).catch((error) => {
          showNotificationBanner({ error: true, renderContent: () => <>Bitte kontrolieren Sie ihre Eingaben.</> });
          console.log(error);
        });
      }} /> : 'Kunde nicht gefunden'}
  </PageWrapper>;
};
